<ion-header class="ion-no-border" translucent>
	<ion-toolbar [class]="transparent ? 'transparent' : ''" class="header">
		<ion-grid>
			<ion-row class="header-row ion-align-items-center">
				<!-- Left (Back button) -->
				@if (showBackBtn) {
					<ion-col class="header-left" size="2">
						<button (click)="onBackClick()" class="back-btn">
							<img [alt]="'header.altBack' | translate" src="/assets/icon/back.svg" />
						</button>
					</ion-col>
				} @else if (!showCenteredSingleLogo) {
					<ion-col class="header-left" size="6" size-xs="5">
						<img [alt]="'header.altLogo' | translate" class="header-logo" src="/assets/icon/brand.svg" />
					</ion-col>
				}

				<!-- Center (Logo) -->
				@if (showBackBtn) {
					<ion-col class="header-center" size="8">
						<img [alt]="'header.altLogo' | translate" class="header-logo" src="/assets/icon/brand.svg" />
					</ion-col>
				} @else if (showCenteredSingleLogo) {
					<ion-col class="header-center" size="12">
						<img [alt]="'header.altLogo' | translate" class="header-logo" src="../../../assets/icon/brand.svg" />
					</ion-col>
				} @else {
					<ion-col class="header-center" size="2" size-xs="auto"></ion-col>
				}

				<!-- Right (Flag) -->
				@if (showLangWithAddress) {
					<ion-col class="header-right" size="4" size-xs="7">
						<h2 class="address">{{ 'statusHeader.address' | translate: { address: address } }}</h2>
						<button (click)="onLangClick()" class="lang-btn">
							<img [alt]="'header.altLanguage' | translate" class="flag" src="/assets/icon/flags/de.svg" />
						</button>
					</ion-col>
				} @else if (showCenteredSingleLogo) {
					<ion-col class="header-right" size="auto"></ion-col>
				} @else {
					<ion-col class="header-right" size="2">
						<button (click)="onLangClick()" class="lang-btn">
							<img [alt]="'header.altLanguage' | translate" class="flag" src="/assets/icon/flags/de.svg" />
						</button>
					</ion-col>
				}
			</ion-row>
		</ion-grid>
	</ion-toolbar>
</ion-header>
